import { defineStore as v } from "pinia";
import { NavigationEvent as h } from "./navigation-event.js";
const b = "_self", L = v("eventBus", () => {
  const i = [];
  function f(e) {
    return e === void 0 || e === "" || e === b;
  }
  function s(e) {
    i.push(e);
  }
  function c(e, t) {
    const n = new h(e, t);
    for (const o of i)
      if (o(n), n.isDefaultPrevented())
        break;
    return n.isDefaultPrevented();
  }
  function a(e, t, n) {
    c(e, t) || (f(t) ? window.location.href = e : window.open(e, t, n));
  }
  function u(e) {
    e.currentTarget instanceof HTMLAnchorElement && (e.preventDefault(), a(e.currentTarget.href, e.currentTarget.target));
  }
  function w(e, t) {
    if (e === "")
      throw new Error("displayFile called with no content");
    const n = URL.createObjectURL(new Blob([e], { type: t }));
    a(n, "_blank"), URL.revokeObjectURL(n);
  }
  function p(e, t, n) {
    if (e === "")
      throw new Error("download called with no filename");
    if (t === "")
      throw new Error("download called with no content");
    const o = URL.createObjectURL(new Blob([t], { type: n }));
    if (!c(o, "_blank")) {
      const r = document.createElement("a");
      r.setAttribute("href", o), r.setAttribute("download", e), r.style.display = "none", document.body.appendChild(r), r.click(), document.body.removeChild(r);
    }
    URL.revokeObjectURL(o);
  }
  function m(e, t, n) {
    if (!e)
      throw new Error("postTo called with no url");
    if (c(e, n))
      return;
    const o = document.createElement("form");
    o.method = "POST", o.action = e, n && (o.target = n), o.style.display = "none";
    for (const r of Object.keys(t)) {
      const d = t[r];
      if (d !== void 0) {
        const l = document.createElement("input");
        l.name = r, l.value = d, o.appendChild(l);
      }
    }
    document.body.appendChild(o), o.submit();
  }
  return {
    navigationEventHandlers: i,
    registerNavigationEventHandler: s,
    navigate: a,
    navigateToHref: u,
    displayFile: w,
    download: p,
    postTo: m
  };
});
export {
  L as useNavigationEventBusStore
};
//# sourceMappingURL=navigation-event-bus-store.js.map
